import { type RowShippingUnit } from "~fulfill/inventory/stock/helpers/rowShippingUnit";
import { MIN_STATED_PACK_SIZE } from "~fulfill/orders/helpers/orderLineUnits";
import { type ConfigCategoryIdentity, findConfigCategory } from "~fulfill/product/helpers/configCategoryDisplay";

export interface ShippingUomItem {
	effectiveEachesPerUnit?: null | number;
	effectiveShippingUomId?: null | string;
}

// The server resolves both halves onto the item, tag-inherited trays included; a count it never stated reads null.
const itemShippingUnit = (
	item: null | ShippingUomItem | undefined,
	configCategories: readonly ConfigCategoryIdentity[]
): null | RowShippingUnit => {
	const shippingUomId = item?.effectiveShippingUomId;
	const eachesPerUnit = item?.effectiveEachesPerUnit;

	if (!shippingUomId || eachesPerUnit == null) return null;
	if (!Number.isInteger(eachesPerUnit) || eachesPerUnit < MIN_STATED_PACK_SIZE) return null;

	const category = findConfigCategory(shippingUomId, configCategories);
	if (!category) return null;

	return { eachesPerUnit, label: category.name || category.code };
};

export default itemShippingUnit;
